import { render, staticRenderFns } from "./Zalihe2.vue?vue&type=template&id=6fab8a43&"
import script from "./Zalihe2.vue?vue&type=script&lang=ts&"
export * from "./Zalihe2.vue?vue&type=script&lang=ts&"
import style0 from "./Zalihe2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports